/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useContext } from 'react'
import _ from 'lodash'
import { RcmTableDataWrapper } from '../../../../../components/rcm-table/RcmTableDataWrapper'
import { PublishContext } from '../publish-context/PublishContext'
import PatientsTable from './PatientsTable'
import { eosApiService } from '../../../../../services/api/api.eos'
import type { PdrDocumentEntry, PdrDocumentsResponse } from '../types'

const PatientSelectionTable: React.FC = () => {
  const publishContext = useContext(PublishContext)
  const { searchString, filter, siteFolderIds, allSitesData } = publishContext?.selectionsData ?? {
    searchString: null,
    filter: { pageStart: 1, pageSize: 10 },
    siteFolderIds: [],
    allSitesData: []
  }

  const loadData = (params: { pageStart: number; pageSize: number }) => {
    let sitesData = siteFolderIds
    if (siteFolderIds?.length === 1 && siteFolderIds[0] === -1) {
      sitesData = _.map(allSitesData, 'siteFolderId')
    }
    return eosApiService
      .getPdrDocuments(searchString ?? '', params?.pageStart + 1, params?.pageSize, sitesData)
      .then((response) => {
        const data = response as PdrDocumentsResponse
        return {
          elements: data.elements.map((item) => ({
            ...item,
            id: item?.documentFsiId
          })),
          totalElements: data.totalElements
        }
      })
  }

  return (
    <RcmTableDataWrapper loadData={loadData} persistenceKey="pdrPatientsTable">
      <PatientsTable />
    </RcmTableDataWrapper>
  )
}

export default PatientSelectionTable
